import { ReactElement } from "react";

interface IIconButtonPrimary {
  onClick?: () => void;
  icon?: ReactElement;
  text: string;
  color: "peach" | "mud";
}

export default function IconButtonPrimary(props: IIconButtonPrimary) {
  return (
    <button
      type="button"
      onClick={props.onClick}
      className={`px-5 py-3 gap-2.5 inline-flex flex-row items-center justify-center rounded-[20px] ${
        props.color === "mud" && "bg-brij-Mud hover:bg-brij-MudDark"
      } ${props.color === "peach" && "bg-brij-Peach"}`}
    >
      {props.icon && <div className="w-5 h-5">{props.icon}</div>}
      <p className="text-normal font-medium text-center inline text-brij-White">
        {props.text}
      </p>
    </button>
  );
}
